module.exports = __webpack_public_path__ + "static/img/8.bafe20c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/sp/8.png
// module id = R8/I
// module chunks = 0